import { Navigation } from '@ydegouvello/ui';
import { InitRoute } from 'routes/init.route';
import { LoginRoute } from 'routes/login.route';
import { LogoutRoute } from 'routes/logout.route';
import { ReportRoute } from 'routes/report.route';

document.addEventListener('DOMContentLoaded', () => void init());

async function init(): Promise<void> {
  InitRoute.getInstance();
  LoginRoute.getInstance();
  LogoutRoute.getInstance();
  ReportRoute.getInstance();

  const navigation = Navigation.getInstance();
  await navigation.start();
}
